import { Switch as StyledSwitch, Form } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./switch.module.scss";

interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label: string;
  checkedText?: string;
  unCheckedText?: string;
  loading?: boolean;
  isVertical?: boolean;
  isSmall?: boolean;
  noMargin?: boolean;
}

const Switch: React.FC<SwitchProps> = ({
  onChange,
  label,
  checkedText = "",
  unCheckedText = "",
  checked = false,
  loading,
  isVertical = false,
  isSmall = false,
  noMargin = false,
}) => {
  const [isChecked, setChecked] = useState<boolean>(false);

  const handleChange = (checkedValue: boolean) => {
    setChecked(checkedValue);

    if (onChange) {
      onChange(checkedValue);
    }
  };

  useEffect(() => {
    setChecked(checked);
  }, []);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  return (
    <Form.Item
      initialValue={{
        isChecked,
      }}
      label={label}
      className={`
        ${styles.switch_form_wrapper} ${isVertical ? styles.switch_form_vertical : ""} ${isSmall ? styles.switch_form_wrapper_small : ""} ${noMargin ? styles.switch_form_no_margin : ""}
      `}
    >
      <StyledSwitch
        loading={loading}
        checked={isChecked}
        onChange={handleChange}
        className={`${styles.switch_form_item} ${isChecked ? "active" : ""}`}
        checkedChildren={checkedText}
        unCheckedChildren={unCheckedText}
      />
    </Form.Item>
  );
};

export default Switch;
